























import { round } from 'lodash-es';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import formatScore from '../../utils/format-score';

@Component({})
class YearFactsChart extends Vue {
  @Prop({}) data: any;

  barWidth(index: number) {
    const values = this.data.values;
    const current = values[index];
    const max = this.data.max || Math.max(...values);
    return `calc(${(current / max) * 100}%)`;
  }

  formatThousands(number: number): number | string {
    if (number > 1999999) {
      const precision = number > 10000000 ? 0 : 1;
      return `${this.formatNumber(round(number / 1000000, precision))}M`;
    }
    if (number > 9999) {
      return `${this.formatNumber(Math.round(number / 1000))}K`;
    }
    return this.formatNumber(number);
  }

  formatNumber(number: number) {
    return formatScore(number);
  }
}
export default YearFactsChart;
